
export const privacidade = {
  hero: {
    label: 'Compliance & Transparency',
    title: 'Privacy Policy',
    subtitle: 'FGT Capital respects and protects the personal data of its clients and visitors, in compliance with the Brazilian General Data Protection Law (LGPD – Law No. 13,709/2018).',
    updated: 'Last updated: January 2025'
  },
  lgpdBadge: 'This document complies with the Brazilian General Data Protection Law (LGPD – Law No. 13,709/2018) and the guidelines of the National Data Protection Authority (ANPD).',
  sections: [
    {
      title: 'Who we are',
      content: [
        'FGT Capital is a company specialized in structuring wealth decisions through regulated consortiums, headquartered in São Paulo/SP – Brazil.',
        'For the purposes of this Policy, FGT Capital acts as the Controller of personal data collected on this website and in its interactions with clients and prospects.',
        'CNPJ and other institutional information are available upon request through the official contact channel.'
      ]
    },
    {
      title: 'Data we collect',
      content: [
        'We collect only the data strictly necessary for the provision of our services and for compliance with legal obligations, including:',
        '• Identification data: full name, CPF/CNPJ (when applicable).',
        '• Contact data: email, WhatsApp/phone number.',
        '• Financial and wealth data: credit value range, installment capacity, investment horizon — collected exclusively in the context of the Strategic Assessment.',
        '• Browsing data: IP address, browser type, pages visited and time spent, collected anonymously via analytics tools.',
        'We do not collect sensitive data (racial origin, religious belief, genetic, biometric data, etc.) under any circumstances.'
      ]
    },
    {
      title: 'Purpose and legal basis for processing',
      content: [
        'The data collected is processed for the following purposes and legal bases provided for in the LGPD:',
        '• Contract execution or preliminary procedures (Art. 7, V): to respond to requests, schedule assessments and provide contracted services.',
        '• Legitimate interest (Art. 7, IX): to send relevant communications about wealth solutions, provided the holder does not object.',
        '• Compliance with legal obligation (Art. 7, II): to meet regulatory requirements of the Central Bank of Brazil and other competent bodies.',
        '• Consent (Art. 7, I): for direct marketing actions, when explicitly requested.'
      ]
    },
    {
      title: 'Data sharing',
      content: [
        'FGT Capital does not sell, rent or transfer personal data to third parties for their own commercial purposes.',
        'Data may be shared exclusively with:',
        '• Consortium administrators authorized by the Central Bank of Brazil, for analysis and structuring of operations.',
        '• Technology service providers (hosting, CRM, transactional email) acting as Processors under confidentiality and LGPD compliance agreements.',
        '• Public authorities, when required by law, court order or applicable regulation.',
        'All partners and suppliers are assessed for LGPD compliance before any data sharing.'
      ]
    },
    {
      title: 'Data retention and deletion',
      content: [
        'Personal data is retained for as long as necessary to fulfill the purposes described in this Policy or to meet legal and regulatory obligations.',
        '• Prospect data (non-clients): retained for up to 24 months after the last contact, unless a prior deletion request is made.',
        '• Client data: retained for the contractual period plus 5 years, as required by the Central Bank and tax legislation.',
        'After the retention period, data is securely deleted or anonymized, making it impossible to identify the holder.'
      ]
    },
    {
      title: 'Information security',
      content: [
        'We adopt appropriate technical and organizational measures to protect personal data against unauthorized access, loss, alteration or improper disclosure, including:',
        '• Data encryption in transit (TLS/HTTPS) and at rest.',
        '• Role-based access control (RBAC), with the principle of least privilege.',
        '• Continuous monitoring of access and security incidents.',
        '• Regular team training on data protection best practices.',
        'In the event of a security incident that may cause relevant risk or damage to holders, the ANPD and those affected will be notified within legal deadlines.'
      ]
    },
    {
      title: 'Rights of data subjects',
      content: [
        'Under the LGPD (Art. 18), you have the following rights regarding your personal data:',
        '• Confirmation and access: to know if we process your data and obtain a copy.',
        '• Correction: to request the update of incomplete, inaccurate or outdated data.',
        '• Anonymization, blocking or deletion: of unnecessary, excessive or non-compliant data.',
        '• Portability: to receive your data in a structured format for transfer to another provider.',
        '• Revocation of consent: at any time, without prejudice to the lawfulness of prior processing.',
        '• Opposition: to processing based on legitimate interest, when not justified.',
        'To exercise any right, contact us at contato@fgt-capital.com or WhatsApp +55 11 93032-2408. We will respond within 15 business days.'
      ]
    },
    {
      title: 'Cookies and tracking technologies',
      content: [
        'We use cookies and similar technologies to improve the browsing experience, analyze traffic and personalize content.',
        '• Essential cookies: necessary for the basic functioning of the site. Cannot be disabled.',
        '• Analytical cookies: collect anonymized information about site usage (e.g.: Google Analytics). Can be refused.',
        '• Marketing cookies: used to display relevant content. Activated only with explicit consent.',
        'You can manage your cookie preferences at any time through your browser settings.'
      ]
    },
    {
      title: 'Changes to this Policy',
      content: [
        'This Policy may be updated periodically to reflect changes in our practices, applicable legislation or ANPD determinations.',
        'Relevant changes will be communicated by email (to registered holders) and/or by a prominent notice on this website.',
        'The date of the last update is indicated at the top of this page. Continued use of the site after publication of changes implies acceptance of the revised Policy.'
      ]
    }
  ],
  dpo: {
    title: 'Data Protection Officer (DPO)',
    description: 'To exercise your rights, clarify questions about this Policy or report any issue related to the processing of personal data, please contact our Data Protection Officer:'
  },
  cta: {
    title: 'Transparency is part of our method',
    subtitle: 'We handle your data with the same rigor we apply to our clients\' wealth decisions. Schedule a Strategic Assessment and learn about our approach.',
    primary: 'Schedule Strategic Assessment',
    secondary: 'Talk to the Team'
  }
};
